import React, { useCallback } from 'react';

import { twMerge } from 'tailwind-merge';

import { useNavigate } from 'react-router-dom';

import Icon from 'components/icon/icon';
import Typography from 'components-new/typography/typography';

export interface HeaderProps {
  className?: string;
  headerTitle?: string;
  showGoBackButton?: boolean;
  onGoBackClick?: () => void;
}

const Header: React.FC<HeaderProps> = (props) => {
  const navigate = useNavigate();

  const onBackButtonClicked = useCallback(() => {
    if (!props.onGoBackClick) {
      navigate(-1);
      return;
    }
    props.onGoBackClick();
  }, [navigate, props]);

  const navigationBarClassNames = twMerge(
    'relative flex justify-center items-center py-4',
    'border-b border-gray100',
    'px-6',
    'bg-white',
  );

  const boxShadow = '0px 4px 8px #97969914';

  return (
    <div
      className={twMerge('flex flex-col sticky top-0 z-10', props.className)}
    >
      <div className={navigationBarClassNames} style={{ boxShadow }}>
        <a
          className="justify-center items-center hidden sm:flex sm:h-full absolute left-1 ml-1 "
          href="/"
        >
          <img
            src={`${window.STATIC_URL}assets/tadaah-logo-2024.svg`}
            height="35px"
            width="128px"
            alt="logo"
          />
        </a>
        <div className="flex justify-center items-center">
          {props.showGoBackButton && (
            <Icon
              icon="rewind"
              className="cursor-pointer mr-2"
              onClick={onBackButtonClicked}
            />
          )}
          <Typography as="h1" variant="heading-1">
            {props.headerTitle}
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default Header;
